(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jlb-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jlb-sticky-atc')) {
    customElements.define(
      'jlb-sticky-atc',
      class JlbStickyAtc extends HTMLElement {
        connectedCallback() {
          this.mainButton = document.querySelector('product-form button[name="add"]');
          if (!this.mainButton) return;
          this.hidden = false;

          this.querySelector('.jlb-sticky__button').addEventListener('click', () => {
            this.mainButton.click();
          });

          this.update = this.update.bind(this);
          this.ticking = false;
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.update();
              this.ticking = false;
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.update();
        }

        update() {
          const passed = this.mainButton.getBoundingClientRect().bottom < 0;
          this.classList.toggle('jlb-sticky--visible', passed);
          this.inert = !passed;
          this.moveChat(passed);
        }

        moveChat(up) {
          const chat = document.querySelector('.karlachat--window-mobile');
          if (!chat) return;
          if (this.chatBottom === undefined) this.chatBottom = chat.style.getPropertyValue('bottom') || '20px';
          chat.style.setProperty('bottom', up ? '92px' : this.chatBottom, 'important');
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jlb-system-addon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-jlb-addon]');
    if (!form) return;
    event.preventDefault();

    const box = form.closest('.jlb-addon');
    const status = box ? box.querySelector('.jlb-addon__status') : null;
    const button = form.querySelector('button');
    if (button) button.disabled = true;

    try {
      const response = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('add failed');
      if (status) status.textContent = 'Lagt i handlekurven.';
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
